import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Trans } from 'react-i18next'
import { Grid } from '@material-ui/core'
import CopilotSettingsEmptyStateIcon from './icons/CopilotSettings/CopilotSettingsEmptyStateIcon'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import usePatientBriefModalOpener from 'components/Patients/PatientCard/PatientBriefTab/usePatientBriefModalOpener'
import useRolePermissions from 'hooks/useRolePermissions'

const useStyles = makeStyles(theme => ({
  copilotSettingsEmptyState: {
    backgroundColor: 'rgba(248, 249, 251, 1)',
    borderRadius: 16,
    padding: '30px'
  },
  button: {
    color: 'rgba(60, 82, 239, 1)',
    textDecoration: 'underline',
    cursor: 'pointer'
  }
}))

const CopilotSettingsEmptyState = () => {
  const classes = useStyles()
  const { permissions } = useRolePermissions()
  const { updatePatientBrief } = usePatientBriefModalOpener({ analyticsSource: 'patient-copilot-settings-empty-state' })

  return (
    <Grid
      container
      className={classes.copilotSettingsEmptyState}
      alignItems="center"
      justifyContent="space-around"
      direction="row"
    >
      <Grid item>
        <CopilotSettingsEmptyStateIcon />
      </Grid>
      <Grid item>
        <DazzedParagraph14>
          <Trans
            i18nKey={
              permissions.updatePatientBrief
                ? 'pages.patients.patientSidebar.items.copilot.copilotSettings.emptyState.bodyWithButton'
                : 'pages.patients.patientSidebar.items.copilot.copilotSettings.emptyState.bodyNoButton'
            }
            components={{
              a: <span className={classes.button} onClick={updatePatientBrief} />
            }}
          />
        </DazzedParagraph14>
      </Grid>
    </Grid>
  )
}

export default CopilotSettingsEmptyState
